
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'NewsSlider';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};



export default class extends AbstractModule {
    constructor(options) {
        super(options);

    }

    init() {
        // Set events and such

        this.carousel = new Swiper(this.$el[0], {
            speed: 400,
            grabCursor: true,
            mousewheel: false,
            loop: true,
            // If we need pagination
            pagination: {
                el: '.js-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        this.$el.on(EVENT.CLICK, '.js-next',(e) => {
            this.carousel.slideNext();
        });

    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
